module.exports = __webpack_public_path__ + "img/pic10.e846bc5f.png";